/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rscu_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Methionine (ATG) and tryptophan (TGG) always have RSCU 1 — they have no synonyms.`)
};

const es_rscu_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La metionina (ATG) y el triptófano (TGG) siempre tienen RSCU 1 — no tienen sinónimos.`)
};

const de_rscu_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Methionin (ATG) und Tryptophan (TGG) haben immer RSCU 1 — sie haben keine Synonyme.`)
};

const nl_rscu_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Methionine (ATG) en tryptofaan (TGG) hebben altijd RSCU 1 — ze hebben geen synoniemen.`)
};

const fr_rscu_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La méthionine (ATG) et le tryptophane (TGG) ont toujours un RSCU de 1 — ils n'ont pas de synonymes.`)
};

const it_rscu_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metionina (ATG) e triptofano (TGG) hanno sempre RSCU 1 — non hanno sinonimi.`)
};

const pt_br2_rscu_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metionina (ATG) e triptofano (TGG) sempre têm RSCU 1 — não possuem sinônimos.`)
};

const pt_rscu_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A metionina (ATG) e o triptofano (TGG) têm sempre RSCU 1 — não têm sinónimos.`)
};

const ja_rscu_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メチオニン (ATG) とトリプトファン (TGG) のRSCUは常に1です — 同義コドンが存在しないためです。`)
};

const zh_rscu_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`甲硫氨酸（ATG）和色氨酸（TGG）的 RSCU 始终为 1——它们没有同义密码子。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rscu_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rscu_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rscu_ex3", locale)
	if (locale === "en") return en_rscu_ex3(inputs)
	if (locale === "es") return es_rscu_ex3(inputs)
	if (locale === "de") return de_rscu_ex3(inputs)
	if (locale === "nl") return nl_rscu_ex3(inputs)
	if (locale === "fr") return fr_rscu_ex3(inputs)
	if (locale === "it") return it_rscu_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_rscu_ex3(inputs)
	if (locale === "pt") return pt_rscu_ex3(inputs)
	if (locale === "ja") return ja_rscu_ex3(inputs)
	return zh_rscu_ex3(inputs)
};